export default "__VITE_ASSET__DsBqyCNj__"